import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { addToast } from '../../../Toasts/actions'

import {
  fetchVipUsersError,
  fetchVipUsersSuccess,
  updateVipUsersEpicError,
  updateVipUsersEpicSuccess,
} from './actions'
import { DATA_REQUEST_ASYNC, UPDATE_DATA_REQUEST_ASYNC } from './constants'

const fetchDataEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(DATA_REQUEST_ASYNC.INITIATE, UPDATE_DATA_REQUEST_ASYNC.SUCCESS).mergeMap(() =>
    api.mailboxes
      .getVipUsersData(store.getState().partnerOptions.selectedCompany?.value)
      .map((response) => fetchVipUsersSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(fetchVipUsersError, error)))
      .takeUntil(action$.ofType(DATA_REQUEST_ASYNC.CANCEL))
  )

const updateVipUsersEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(UPDATE_DATA_REQUEST_ASYNC.INITIATE).mergeMap((action) =>
    api.mailboxes
      .updateVipUsersData(
        store.getState().partnerOptions.selectedCompany?.value,
        action.payload.data?.map((e) => [e.profileId, e.title, !e.selected])
      )
      .mergeMap((response) => {
        if (response.response.vipProfilesLength) {
          return Observable.of(
            addToast({
              message: "'vip_impersonation' tags were successfully added to the selected profiles",
            }),
            updateVipUsersEpicSuccess(response)
          )
        } else {
          return Observable.of(updateVipUsersEpicSuccess(response))
        }
      })
      .catch((error) => Observable.of(epicsErrorHandler(updateVipUsersEpicError, error)))
      .takeUntil(action$.ofType(UPDATE_DATA_REQUEST_ASYNC.CANCEL))
  )

export default combineEpics(fetchDataEpic, updateVipUsersEpic)
